import { rootUiActions, rootUiTypes } from 'app-components/flux/root-ui';
import { Map as ImmutableMap } from 'immutable';
import { createAction } from 'redux-actions';

export const DIALOG_TYPE = 'COBROWSE_CODE_FETCH_DIALOG';

export const COBROWSE_CODE_FETCH_DIALOG_ID = 'cobrowse-code-fetch-dialog';

export const cobrowseCodeFetchDialog = createAction(
  rootUiActions.createDialog.toString(),
  ({ onClose }: { onClose: () => void }) =>
    rootUiTypes.mkRootUiData({
      id: COBROWSE_CODE_FETCH_DIALOG_ID,
      type: DIALOG_TYPE,
      allowNesting: true,
      props: ImmutableMap({ onClose }),
    }),
);
